"use client";

import { useEffect } from "react";
import { useAuth } from "@/auth/hooks/clerk-hooks";

const LAST_ORG_ID_STORAGE_KEY = "studystash:last_org_id";

export default function RememberOrg() {
	const { isSignedIn, orgId } = useAuth();

	useEffect(() => {
		if (isSignedIn && orgId) {
			try {
				localStorage.setItem(LAST_ORG_ID_STORAGE_KEY, orgId);
			} catch {
				// ignore (private mode / storage disabled)
			}
		}
	}, [isSignedIn, orgId]);

	return null;
}

export function get__org_id() {
	try {
		return localStorage.getItem(LAST_ORG_ID_STORAGE_KEY);
	} catch {
		return null;
	}
}
